import React from 'react';
import beautyCulter from "../../assets/img/about/Image-beauty-culter.jpg"


const BeautyCultureSectoin = () => {
    return (
        <div className='flex-1 md:flex justify-between gap-2 items-center mb-2 mt-28'>
 <div className='mb-6 md:mb-0'>
            <div className='mb-7 text-center md:text-start'>
            <h1 className='font-bold text-3xl md:text-4xl text-[#0F1228] mb-6 md:w-[374px]'>Our Beauty
             Culture Company’s</h1>
             <p className='text-lg font-normal max-w-[450px]'>
             Like Steve Jobs quotes, “Design is not just what
             it looks like and feels like. Design is how it works”. We always try to make a great output by this culture:
             </p>
            </div>
            
             <div className='grid grid-cols-2 gap-4 text-center'>
<div className='flex gap-2 items-center mb-2'>
<svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.39843 7.8242L0.136718 4.58202C0.0455727 4.49088 0 4.37369 0 4.23046C0 4.08723 0.0455727 3.97004 0.136718 3.8789L0.859373 3.17577C0.950519 3.07161 1.06445 3.01953 1.20117 3.01953C1.33789 3.01953 1.45833 3.07161 1.5625 3.17577L3.74999 5.36327L8.43748 0.675781C8.54165 0.571615 8.66209 0.519531 8.79881 0.519531C8.93553 0.519531 9.04946 0.571615 9.1406 0.675781L9.86326 1.3789C9.9544 1.47005 9.99998 1.58724 9.99998 1.73047C9.99998 1.87369 9.9544 1.99088 9.86326 2.08203L4.10155 7.8242C4.01041 7.92837 3.89322 7.98045 3.74999 7.98045C3.60676 7.98045 3.48958 7.92837 3.39843 7.8242Z" fill="#FA8232"/>
</svg>
<h1 className='text-base'>
Fast Delivery
</h1>
</div>
<div className='flex gap-2 items-center mb-2'>
<svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.39843 7.8242L0.136718 4.58202C0.0455727 4.49088 0 4.37369 0 4.23046C0 4.08723 0.0455727 3.97004 0.136718 3.8789L0.859373 3.17577C0.950519 3.07161 1.06445 3.01953 1.20117 3.01953C1.33789 3.01953 1.45833 3.07161 1.5625 3.17577L3.74999 5.36327L8.43748 0.675781C8.54165 0.571615 8.66209 0.519531 8.79881 0.519531C8.93553 0.519531 9.04946 0.571615 9.1406 0.675781L9.86326 1.3789C9.9544 1.47005 9.99998 1.58724 9.99998 1.73047C9.99998 1.87369 9.9544 1.99088 9.86326 2.08203L4.10155 7.8242C4.01041 7.92837 3.89322 7.98045 3.74999 7.98045C3.60676 7.98045 3.48958 7.92837 3.39843 7.8242Z" fill="#FA8232"/>
</svg>
<h1 className='text-base'>
100 authentic
</h1>
</div>
<div className='flex gap-2 items-center mb-2'>
<svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.39843 7.8242L0.136718 4.58202C0.0455727 4.49088 0 4.37369 0 4.23046C0 4.08723 0.0455727 3.97004 0.136718 3.8789L0.859373 3.17577C0.950519 3.07161 1.06445 3.01953 1.20117 3.01953C1.33789 3.01953 1.45833 3.07161 1.5625 3.17577L3.74999 5.36327L8.43748 0.675781C8.54165 0.571615 8.66209 0.519531 8.79881 0.519531C8.93553 0.519531 9.04946 0.571615 9.1406 0.675781L9.86326 1.3789C9.9544 1.47005 9.99998 1.58724 9.99998 1.73047C9.99998 1.87369 9.9544 1.99088 9.86326 2.08203L4.10155 7.8242C4.01041 7.92837 3.89322 7.98045 3.74999 7.98045C3.60676 7.98045 3.48958 7.92837 3.39843 7.8242Z" fill="#FA8232"/>
</svg>
<h1 className='text-base'>
Hungry for Explorations
</h1>
</div>
<div className='flex gap-2 items-center mb-2'>
<svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.39843 7.8242L0.136718 4.58202C0.0455727 4.49088 0 4.37369 0 4.23046C0 4.08723 0.0455727 3.97004 0.136718 3.8789L0.859373 3.17577C0.950519 3.07161 1.06445 3.01953 1.20117 3.01953C1.33789 3.01953 1.45833 3.07161 1.5625 3.17577L3.74999 5.36327L8.43748 0.675781C8.54165 0.571615 8.66209 0.519531 8.79881 0.519531C8.93553 0.519531 9.04946 0.571615 9.1406 0.675781L9.86326 1.3789C9.9544 1.47005 9.99998 1.58724 9.99998 1.73047C9.99998 1.87369 9.9544 1.99088 9.86326 2.08203L4.10155 7.8242C4.01041 7.92837 3.89322 7.98045 3.74999 7.98045C3.60676 7.98045 3.48958 7.92837 3.39843 7.8242Z" fill="#FA8232"/>
</svg>
<h1 className='text-base'>
Weekly Evaluation 
</h1>
</div>
<div className='flex gap-2 items-center mb-2'>
<svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.39843 7.8242L0.136718 4.58202C0.0455727 4.49088 0 4.37369 0 4.23046C0 4.08723 0.0455727 3.97004 0.136718 3.8789L0.859373 3.17577C0.950519 3.07161 1.06445 3.01953 1.20117 3.01953C1.33789 3.01953 1.45833 3.07161 1.5625 3.17577L3.74999 5.36327L8.43748 0.675781C8.54165 0.571615 8.66209 0.519531 8.79881 0.519531C8.93553 0.519531 9.04946 0.571615 9.1406 0.675781L9.86326 1.3789C9.9544 1.47005 9.99998 1.58724 9.99998 1.73047C9.99998 1.87369 9.9544 1.99088 9.86326 2.08203L4.10155 7.8242C4.01041 7.92837 3.89322 7.98045 3.74999 7.98045C3.60676 7.98045 3.48958 7.92837 3.39843 7.8242Z" fill="#FA8232"/>
</svg>
<h1 className='text-base'>
Halal Beauty Product
</h1>
</div>

<div className='flex gap-2 items-center mb-2'>
<svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.39843 7.8242L0.136718 4.58202C0.0455727 4.49088 0 4.37369 0 4.23046C0 4.08723 0.0455727 3.97004 0.136718 3.8789L0.859373 3.17577C0.950519 3.07161 1.06445 3.01953 1.20117 3.01953C1.33789 3.01953 1.45833 3.07161 1.5625 3.17577L3.74999 5.36327L8.43748 0.675781C8.54165 0.571615 8.66209 0.519531 8.79881 0.519531C8.93553 0.519531 9.04946 0.571615 9.1406 0.675781L9.86326 1.3789C9.9544 1.47005 9.99998 1.58724 9.99998 1.73047C9.99998 1.87369 9.9544 1.99088 9.86326 2.08203L4.10155 7.8242C4.01041 7.92837 3.89322 7.98045 3.74999 7.98045C3.60676 7.98045 3.48958 7.92837 3.39843 7.8242Z" fill="#FA8232"/>
</svg>
<h1 className='text-base'>
Update for th Trend
</h1>
</div>

             </div>
        </div>
        <div>
<img src={beautyCulter} alt="" className='mx-auto w-[315px] md:w-[455px] md:h-[520px]'/>
        </div>
        </div>
       
    );
};

export default BeautyCultureSectoin;